/**
 * react-dates@21.8.0 is unmaintained and still ships function components that
 * declare `defaultProps`, which React 18 flags with a deprecation warning at
 * every render. Filter only those specific warnings — anything else still goes
 * through untouched.
 *
 * Why: removing react-dates means a much larger migration; until then this
 * keeps the dev console actionable.
 */

const REACT_DATES_COMPONENTS = new Set([
    'CalendarDay',
    'CalendarIcon',
    'CalendarMonth',
    'CalendarMonthGrid',
    'ChevronDown',
    'ChevronUp',
    'CloseButton',
    'CustomizableCalendarDay',
    'DateInput',
    'DateRangePicker',
    'DateRangePickerInput',
    'DateRangePickerInputController',
    'DayPicker',
    'DayPickerKeyboardShortcuts',
    'DayPickerNavigation',
    'DayPickerRangeController',
    'DayPickerSingleDateController',
    'KeyboardShortcutRow',
    'LeftArrow',
    'RightArrow',
    'SingleDatePicker',
    'SingleDatePickerInput',
    'SingleDatePickerInputController',
]);

const DEFAULT_PROPS_WARNING = 'Support for defaultProps will be removed from function components';

export function suppressReactDatesWarnings(): void {
    const originalError = console.error;
    console.error = (...args: unknown[]) => {
        const [first, second] = args;
        if (
            typeof first === 'string' &&
            first.includes(DEFAULT_PROPS_WARNING) &&
            typeof second === 'string' &&
            REACT_DATES_COMPONENTS.has(second)
        ) {
            return;
        }
        originalError(...args);
    };
}
